import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

export const WidgetContext = createContext();

export const useWidgetContext = () => useContext(WidgetContext);

const WidgetProvider = ({ children }) => {
  // universal
  // Note: use this sparingly, make sure at any given time, only one update source is setting this value
  // will cause unexpected side effects when having multiple simultaneous update sources
  const [isGroupKeyNavDisabled, setIsGroupKeyNavDisabled] = useState(false);

  const [editActiveWidget, setEditActiveWidget] = useState(null);

  const editNotesVersions = (widgetId) => {
    setEditActiveWidget(widgetId);
  };

  // assessments filter ref
  const assessmentsFilterEscapeRef = useRef(null);

  // disable widgets group key nav if
  // - any additional actions dialog is shown
  useEffect(() => {
    const allAdditionalDialogsClosed = !editActiveWidget;
    setIsGroupKeyNavDisabled(!allAdditionalDialogsClosed);
  }, [editActiveWidget]);

  const customiseClock = (widgetId) => {
    setEditActiveWidget({
      widgetId,
      action: 'customiseClock',
    });
  };

  return (
    <WidgetContext.Provider
      value={{
        // universal
        isGroupKeyNavDisabled,
        setIsGroupKeyNavDisabled,
        editActiveWidget,
        setEditActiveWidget,
        // edit clock bg dialog
        customiseClock,
        // edit assessments filter dialog
        editAssessmentsFilter: setEditActiveWidget,
        editNotesVersions,
        assessmentsFilterEscapeRef,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};

export default WidgetProvider;
